// extracted by mini-css-extract-plugin
module.exports = {"feature":"articleLayout_feature__Sx7ox","basic":"articleLayout_basic__gcpQk","corporateHubTip":"articleLayout_corporateHubTip__UaDe6","badge":"articleLayout_badge__9wgth"};